export const enum SearchStatuses {
  QUEUED = 'Queued',
  IN_PROGRESS = 'InProgress',
  NOT_APPLICABLE = 'NotApplicable',
  NO_DATA = 'NoData',
  FAILED = 'Failed',
  COMPLETED = 'Completed',
}

export const enum SearchTypes {
  Credit = 'Credit',
  AVM = 'AVM',
}

export type Search = {
  type?: SearchTypes,
  status: SearchStatuses,
  errorMessage?: string,
};

export const defaultSearch: Search = {
  status: SearchStatuses.NO_DATA,
  errorMessage: '',
};
